import { render } from "./TransferenciaEstoqueModal.vue?vue&type=template&id=623925c9&scoped=true&ts=true"
import script from "./TransferenciaEstoqueModal.vue?vue&type=script&lang=ts"
export * from "./TransferenciaEstoqueModal.vue?vue&type=script&lang=ts"

import "./TransferenciaEstoqueModal.vue?vue&type=style&index=0&id=623925c9&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623925c9"]])

export default __exports__